import React from "react";

// Shows a recovery screen instead of a blank page when rendering crashes (e.g. memory pressure on iPad Safari).
export class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Render crash", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-[#F6F1EA]" data-testid="error-boundary-fallback">
        <div className="max-w-md w-full rounded-2xl border border-[#DDD3C6] bg-white p-6 text-center space-y-4">
          <h1 className="text-xl font-semibold text-[#3A322B]">Un problème est survenu</h1>
          <p className="text-sm text-[#6B5F53]">
            La page n'a pas pu s'afficher correctement. Rechargez-la pour reprendre votre création ; si le problème
            persiste, essayez avec une photo plus légère.
          </p>
          <button type="button" onClick={() => window.location.reload()} data-testid="error-boundary-reload"
            className="rounded-full bg-[#3A322B] text-white px-5 py-2 text-sm">
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}
